import { Box } from "@wix/design-system";
import React from "react";
import { FooterActions, SidePanelLayout, ToggleButton } from "./../../ui-components";
import { SETTINGS_ALLOW_DOWNALOD_TOGGLE, SETTINGS_SPOILER_TOGGLE } from "../dataHooks";
const VideoSettings = ({
  componentData,
  t,
  settings,
  onSave,
  onCancel,
  updateData,
  shouldShowSpoiler
}) => {
  const hasDisableDownload = componentData.disableDownload !== void 0 && componentData.disableDownload !== null;
  const isCustomVideo = hasDisableDownload || componentData.video?.src?.id;
  const disableDownload = hasDisableDownload ? componentData.disableDownload : !!settings?.disableDownload;
  const isSpoilered = componentData.containerData?.spoiler?.enabled;
  return /* @__PURE__ */ React.createElement(
    SidePanelLayout,
    {
      onCloseButtonClick: onCancel,
      header: { title: t("VideoPlugin_Settings_Header") },
      content: {
        children: /* @__PURE__ */ React.createElement(Box, { direction: "vertical", height: "100%", gap: "SP4" }, isCustomVideo ? /* @__PURE__ */ React.createElement(
          ToggleButton,
          {
            title: t("VideoPlugin_Settings_VideoCanBeDownloaded_Label"),
            checked: !disableDownload,
            onChange: () => updateData?.({ disableDownload: !disableDownload }),
            infoContent: t("VideoPlugin_Settings_VideoCanBeDownloaded_Tooltip"),
            dataHook: SETTINGS_ALLOW_DOWNALOD_TOGGLE
          }
        ) : null, shouldShowSpoiler ? /* @__PURE__ */ React.createElement(
          ToggleButton,
          {
            title: t("VideoSettings_Spoiler_Toggle"),
            checked: isSpoilered,
            onChange: () => {
              updateData?.({
                containerData: {
                  ...componentData.containerData,
                  spoiler: { enabled: !isSpoilered }
                }
              });
            },
            infoContent: t("Spoiler_Toggle_Tooltip"),
            dataHook: SETTINGS_SPOILER_TOGGLE
          }
        ) : null)
      },
      footer: { children: /* @__PURE__ */ React.createElement(FooterActions, { onCancel, onSave }) }
    }
  );
};
export {
  VideoSettings
};
//# sourceMappingURL=VideoSettings.js.map
